module.exports = __webpack_public_path__ + "img/login-bg.8f73b374.png";